import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Cookie from '../components/Cookie';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();
  const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);

  const openCookieModal = () => setIsCookieModalOpen(true);
  const closeCookieModal = () => setIsCookieModalOpen(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');

    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <>
      {/* Çerez İzin Modal */}
      {isVisible && (
        <div className="fixed bottom-0 left-0 right-0 flex items-center justify-center bg-opacity-60 bg-[#1f1f2c] backdrop-blur-lg z-50">
          <div className="w-full max-w-6xl mx-4 p-4 rounded-lg shadow-lg text-white">
            <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <p className="text-sm sm:text-base text-center sm:text-left">
                {t('cookie')}
                <button
                  onClick={openCookieModal}
                  className="text-sm text-white hover:text-[#dcbc5c] transition-all ml-2 underline"
                >
                  {t('footerpolicy')}
                </button>
              </p>

              <div className="flex flex-row  space-x-5  w-full sm:w-auto">
                <button
                  className="px-4 py-2 bg-[#dcbc5c] text-white rounded-2xl hover:bg-[#b69f49] focus:outline-none focus:ring-2 focus:ring-[#dcbc5c] w-full sm:w-[150px]"
                  onClick={handleAccept}
                >
                  {t('accept')}
                </button>
                <button
                  className="px-4 py-2 bg-[#36364d] text-white rounded-2xl hover:bg-[#46465d] focus:outline-none focus:ring-2 focus:ring-gray-500 w-full sm:w-[150px]"
                  onClick={handleReject}
                >
                  {t('reject')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      <Cookie isOpen={isCookieModalOpen} onClose={closeCookieModal} />
    </>
  );
};

export default CookieConsent;
